import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AiFillYoutube } from "react-icons/ai";
import { FaTiktok, FaGoogleDrive, FaVideo, FaImage } from "react-icons/fa";
import { MdVideoLibrary } from "react-icons/md";
import Particle from "../Particle";

// ===========================================
// 📺 YOUTUBE CHANNELS I EDITED FOR
// ===========================================
const youtubeChannels = [
  {
    name: "FactSnack11",
    url: "https://www.youtube.com/@FactSnack11",
    description: "Educational content & reels",
  },
  {
    name: "b1kjuu_editz",
    url: "https://www.youtube.com/@b1kjuu_editz",
    description: "Hype & meme edits",
  },
];

// ===========================================
// 🎵 TIKTOK FOR PHOTO EDITS
// ===========================================
const tiktokAccount = {
  name: "_sa.pagkubli_",
  url: "https://www.tiktok.com/@_sa.pagkubli_",
  description: "Photo & poster designs",
};

// ===========================================
// 📁 GOOGLE DRIVE VIDEO PORTFOLIO
// ===========================================
const driveLink = "https://drive.google.com/drive/folders/1v4y_SjGo8S8ipR3gkDxZ8JqrIzX-3qhM?usp=sharing";

// Service card component
function ServiceCard({ icon, title, description }) {
  return (
    <div
      className="project-card-view"
      style={{
        padding: "30px 20px",
        textAlign: "center",
        height: "100%",
      }}
    >
      <div style={{ fontSize: "3rem", color: "#00d9ff", marginBottom: 15 }}>
        {icon}
      </div>
      <h4 style={{ color: "white", marginBottom: 10 }}>{title}</h4>
      <p style={{ color: "#aaa", fontSize: "0.9rem" }}>{description}</p>
    </div>
  );
}

// Link card component
function LinkCard({ icon, iconColor, title, subtitle, url }) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      style={{ textDecoration: "none" }}
    >
      <div
        className="project-card-view"
        style={{
          padding: "25px 20px",
          textAlign: "center",
          height: "100%",
          cursor: "pointer",
          transition: "transform 0.3s, box-shadow 0.3s",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-5px)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
        }}
      >
        <div style={{ fontSize: "3.5rem", color: iconColor, marginBottom: 12 }}>
          {icon}
        </div>
        <h5 style={{ color: "white", marginBottom: 5 }}>{title}</h5>
        <p style={{ color: "#888", fontSize: "0.8rem", margin: 0 }}>{subtitle}</p>
      </div>
    </a>
  );
}

function Editing() {
  return (
    <Container fluid className="project-section" style={{ minHeight: "100vh" }}>
      <Particle />
      <Container>
        <h1 className="project-heading">
          Editing <strong className="purple">Showcase</strong>
        </h1>
        <p style={{ color: "white", fontSize: "1.1rem" }}>
          I offer <strong className="purple">video editing</strong> and{" "}
          <strong className="purple">photo/poster editing</strong> services. Check out my work below!
        </p>

        {/* Services Section */}
        <h3 style={{ color: "white", marginTop: 50, marginBottom: 25, textAlign: "center" }}>
          <MdVideoLibrary style={{ marginRight: 10 }} />
          What I Offer
        </h3>
        <Row style={{ justifyContent: "center", marginBottom: 40 }}>
          <Col md={4} sm={6} style={{ marginBottom: 20 }}>
            <ServiceCard
              icon={<FaVideo />}
              title="Video Editing"
              description="Short-form reels, long-form content, promos, ads, and cinematic edits for any platform."
            />
          </Col>
          <Col md={4} sm={6} style={{ marginBottom: 20 }}>
            <ServiceCard
              icon={<FaImage />}
              title="Photo & Poster Design"
              description="Eye-catching posters, thumbnails, social media graphics, and promotional materials."
            />
          </Col>
        </Row>

        {/* Portfolio Links Section */}
        <h3 style={{ color: "white", marginTop: 30, marginBottom: 25, textAlign: "center" }}>
          🎬 My Portfolio
        </h3>
        <Row style={{ justifyContent: "center", paddingBottom: 50 }}>
          {youtubeChannels.map((ch, idx) => (
            <Col key={idx} lg={3} md={4} sm={6} style={{ marginBottom: 20 }}>
              <LinkCard
                icon={<AiFillYoutube />}
                iconColor="#ff0000"
                title={ch.name}
                subtitle={ch.description}
                url={ch.url}
              />
            </Col>
          ))}
          <Col lg={3} md={4} sm={6} style={{ marginBottom: 20 }}>
            <LinkCard
              icon={<FaTiktok />}
              iconColor="#00f2ea"
              title={`@${tiktokAccount.name}`}
              subtitle={tiktokAccount.description}
              url={tiktokAccount.url}
            />
          </Col>
          <Col lg={3} md={4} sm={6} style={{ marginBottom: 20 }}>
            <LinkCard
              icon={<FaGoogleDrive />}
              iconColor="#4285F4"
              title="All Videos"
              subtitle="Full video portfolio"
              url={driveLink}
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Editing;
